import api from '../index';
var namespace = 'check-video.test.classba.cn';
var routerTips = 'routertips.test.classba.cn';
if (!window.top.location.host.includes('.test') && !window.top.location.host.includes(':80')) {
    routerTips = 'routertips.classba.cn';
    namespace = 'check-video.classba.cn';
}
var feature = 'check_m3u8.php';
export var getVideo = function getVideo(params) {
    return api.post('//'.concat(namespace, '/').concat(feature), params);
};
export var errorVideo = function errorVideo(params) {
    return api.post('//'.concat(namespace, '/send_netbreak.php'), params);
};
export var heartbeatVideo = function heartbeatVideo(params) {
    return api.post('//'.concat(routerTips, '/tips_heartbeat'), params);
};